// @flow

import React, { type Node, useMemo, Fragment } from 'react';
import { Separator } from '../../../../commons/atoms';
import styled from 'styled-components';
import { useScreenWidth } from '@tectonics/hooks';
import { getOxxoBarcode, usePendingIncomingPayment } from '@tectonics/prs/incoming-payment';
import { timesGroupSplitter, timesGroupSlicer } from '@tectonics/look-and-feel/commons/format-utils';

export function OxxoNumberDisplay(): Node {
  const incomingPayment = usePendingIncomingPayment();

  return <OxxoNumber oxxoCode={getOxxoBarcode(incomingPayment)} />;
}

type OxxoNumberProps = {|
  oxxoCode: string,
|};

function useSafeSplitOxxoCode(oxxoCode: string): ImmutableArray<string> {
  const splitOxxoCode = useMemo(() => timesGroupSplitter(4, oxxoCode), [oxxoCode]);
  if (!splitOxxoCode.length) {
    throw new Error('Split Oxxo Code is Null');
  }
  return splitOxxoCode;
}

function OxxoNumber({ oxxoCode }: OxxoNumberProps): Node {
  const screenWidth = useScreenWidth();
  const isMobile = screenWidth <= 840;
  const splitOxxoCode = useSafeSplitOxxoCode(oxxoCode);
  return (
    <OxxoNumberWrapper>
      {timesGroupSlicer(4, splitOxxoCode).map((slice, index) => (
        <Fragment key={index}>
          <OxxoNumberRow oxxoNumberArray={slice} />
          {index > 0 && isMobile && <Separator direction="vertical" size={1} />}
        </Fragment>
      ))}
    </OxxoNumberWrapper>
  );
}

type OxxoNumberRowProps = {|
  oxxoNumberArray: Array<string>,
|};

function OxxoNumberRow({ oxxoNumberArray }: OxxoNumberRowProps): Node {
  return oxxoNumberArray.map((element, index) => (
    <OxxoNumberSection key={index}>{element}</OxxoNumberSection>
  ));
}

const OxxoNumberSection = styled.div`
  background-color: rgb(248, 248, 249);
  color: rgb(115, 128, 147);
  font-family: ${props => props.theme.fontFamily.display};
  font-size: 16px;
  font-weight: bold;
  border-radius: 7px;
  text-align: center;
  width: 21%;
  padding: 5px 10px;
  margin: 5px 0px;
`;

const OxxoNumberWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-around;
`;
